/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { FetchModelResponse, IFetchModel } from '@cian/http-api';
import type { IGetRealtorsResponse } from '../../entities/get_agents/GetRealtorsResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetRealtorsRequest {
  dealType?: EQueryParameters;
  limit?: number;
  offerType?: EQueryParameters_1[];
  page?: number;
  regionId: number;
  searchText?: string;
  sortBy?: EQueryParameters_2;
}

export enum EQueryParameters {
  /** Аренда **/
  'Rent' = 'rent',
  /** Продажа **/
  'Sale' = 'sale',
}
export enum EQueryParameters_1 {
  /** Коммерческая **/
  'Commercial' = 'commercial',
  /** Жилая **/
  'Flat' = 'flat',
  /** Загородная **/
  'Suburban' = 'suburban',
}
export enum EQueryParameters_2 {
  /** По времени на Циан **/
  'Age' = 'age',
  /** По имени/названию **/
  'Name' = 'name',
  /** По количеству объявлений **/
  'OffersCount' = 'offersCount',
}
export type TGetRealtorsResponse =
  | FetchModelResponse<200, 'json', IGetRealtorsResponse>
  | FetchModelResponse<400, 'json', IErrorResponseSchema>;

export type TGetRealtorsModel = IFetchModel<IGetRealtorsRequest, undefined, TGetRealtorsResponse>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetRealtorsResponse, headers: Headers): TResponse200;
  400(response: IErrorResponseSchema, headers: Headers): TResponse400;
}
